import { CommonHelper } from "@/Common/Helpers/CommonHelper";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { IPrescriptionTabModel } from "@/Patient/Models/UI/Medication/IPrescriptionTabModel";
import { PrescriptionRenewalInboxSettings } from "@/PrescriptionRenewals/Models/PrescriptionRenewalInboxSettings";
import { PrescriptionRenewalMedicationHistoryFilterSettingModel } from "@/PrescriptionRenewals/Models/PrescriptionRenewalMedicationHistoryFilterSettingModel";
import { PrescriptionRenewalMedications } from "@/PrescriptionRenewals/Models/PrescriptionRenewalMedications";
import { PrescriptionRenewalModel } from "@/PrescriptionRenewals/Models/PrescriptionRenewalModel";
import { PrescriptionRenewalsStore } from "@/PrescriptionRenewals/Stores/PrescriptionRenewalsStore";

class PrescriptionRenewalsHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.PrescriptionRenewal.SetPrescriptionRenewalInboxSettings, this.setPrescriptionRenewalInboxSettings);
        this.RegisterOperation(LocalOperations.PrescriptionRenewal.SetPrescriptionRenewalModel, this.setPrescriptionRenewalModel);
        this.RegisterOperation(LocalOperations.PrescriptionRenewal.SetPrescriptionRenewalCachedModel, this.setPrescriptionRenewalCachedModel);
        this.RegisterOperation(LocalOperations.PrescriptionRenewal.SetPrescriptionRenewalHistoryFilterSetting, this.setPrescriptionRenewalHistoryFilterSetting);
        this.RegisterOperation(LocalOperations.PrescriptionRenewal.ClearPrescriptionRenewalCache, this.clearPrescriptionRenewalCache);
        this.RegisterOperation(LocalOperations.PrescriptionRenewal.SavePrescriptionRenewalsViewTogglerSession, this.savePrescriptionRenewalsViewTogglerSession);
    }

    private setPrescriptionRenewalInboxSettings(request: LocalEvent, store: PrescriptionRenewalsStore): void {
        store.prescriptionRenewalInboxSettings = request.Get<PrescriptionRenewalInboxSettings>("prescriptionRenewalInboxSettings");
    }

    private setPrescriptionRenewalModel(request: LocalEvent, store: PrescriptionRenewalsStore): void {
        store.prescriptionRenewalModel = request.Get<PrescriptionRenewalModel>("prescriptionRenewalModel");
    }

    private setPrescriptionRenewalCachedModel(request: LocalEvent, store: PrescriptionRenewalsStore): void {
        const prescriptionRenewalId = request.Get<string>("prescriptionRenewalId");
        const prescriptionTabModel = request.Get<IPrescriptionTabModel>("prescriptionTabModel");
        const prescriptionRenewalMedications = request.Get<PrescriptionRenewalMedications[]>("prescriptionRenewalMedications");
        const prescriptionRenewalNote = request.Get<string>("prescriptionRenewalNote");
        const isDirty = request.Get<boolean>("isDirty");

        store.prescriptionRenewalCachedModel[prescriptionRenewalId] = {
            prescriptionTabModel: CommonHelper.getCloneDeep(prescriptionTabModel),
            prescriptionRenewalMedications: CommonHelper.getCloneDeep(prescriptionRenewalMedications),
            prescriptionRenewalNote,
            isDirty
        };
    }

    private setPrescriptionRenewalHistoryFilterSetting(request: LocalEvent, store: PrescriptionRenewalsStore): void {
        const prescriptionRenewalId = request.Get<string>("prescriptionRenewalId");
        const prescriptionRenewalHistoryFilterSetting = request.Get<PrescriptionRenewalMedicationHistoryFilterSettingModel>("prescriptionRenewalHistoryFilterSetting");

        store.prescriptionRenewalHistoryFilterSetting[prescriptionRenewalId] = CommonHelper.getCloneDeep(prescriptionRenewalHistoryFilterSetting);
    }

    private clearPrescriptionRenewalCache(_: LocalEvent, store: PrescriptionRenewalsStore): void {
        store.prescriptionRenewalCachedModel = {};
        store.prescriptionRenewalHistoryFilterSetting = {};
        store.isPrescriptionRenewalsViewPdfViewerExpanded = null;
        store.isPrescriptionRenewalsViewRenewMedicationHeaderExpanded = null;
    }

    private savePrescriptionRenewalsViewTogglerSession(request: LocalEvent, store: PrescriptionRenewalsStore): void {
        const isPrescriptionRenewalsViewPdfViewerExpanded = request.Get<boolean>("isPrescriptionRenewalsViewPdfViewerExpanded");
        const isPrescriptionRenewalsViewRenewMedicationHeaderExpanded = request.Get<boolean>("isPrescriptionRenewalsViewRenewMedicationHeaderExpanded");

        if (!IsNullOrUndefined(isPrescriptionRenewalsViewPdfViewerExpanded)) {
            store.isPrescriptionRenewalsViewPdfViewerExpanded = isPrescriptionRenewalsViewPdfViewerExpanded;
        }

        if (!IsNullOrUndefined(isPrescriptionRenewalsViewRenewMedicationHeaderExpanded)) {
            store.isPrescriptionRenewalsViewRenewMedicationHeaderExpanded = isPrescriptionRenewalsViewRenewMedicationHeaderExpanded;
        }
    }
}

export { PrescriptionRenewalsHandler };
